import React from "react";
import { useSelector } from "react-redux";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as AddIcon } from "../../../assets/Images/AddIcon.svg";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import SearchBar from "../Common/Search/SearchBar";
import { getCustomWriteAccess } from "../CommonComponents/Common";

const AudienceHeader = ({ searchText, toggle, setState, viewListShow }) => {
  const reducer: any = useSelector((state) => state);

  const {
    AudienceReducer: { audienceCount },
  } = reducer;
  return (
    <Box className="flex-between pb-3" >
      <Box className="flex-xy-center gap-2">
        <Typography className="font-20-grey">Audiences</Typography>
        <Typography
          className="font-14-lightgrey"
          component="span"
          sx={commonStyles.textInfo}
        >
          Total{" "}
          <span className="font-20-700-lightgrey">{audienceCount || 0}</span>
        </Typography>
      </Box>
      {!viewListShow && (
        <Box
          className="flex-xy-center gap-2" >
          <SearchBar
            searchText={searchText}
            handleChange={(e) => {
              e.persist();
              setState((prev) => ({
                ...prev,
                searchText: e.target.value,
              }));
            }}
          />

          {getCustomWriteAccess(reducer) === "write" && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={toggle}
            >
              Add New Audience
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AudienceHeader;
